import React, { useState } from 'react';
import {
  Box,
  Button
} from '@material-ui/core';

import EmployeesTable from 'components/Employees/EmployeesTable';
import EmployeeDetails from 'components/Employees/EmployeeDetails';

const EmployeeListResults = (props) => {
  
  const [open, setOpen] = useState(false);
  const [update, setUpdate] = useState(false);
  const [updateInfo, setUpdateInfo] = useState({});

  const addEmployee = () => {
    setOpen(true);
    setUpdate(false);
    setUpdateInfo({});
  };

  const updateEmployee = () => {
    setOpen(true);
    setUpdate(true);
  };

  const cancelAddUpdate = () => {
    setOpen(false);
    setUpdate(false);
    setUpdateInfo({});
  };

  const createEmployeeDisplayId = () => {
    const length = props.idGen.find(idGen => idGen.info.user === props.activeUserId).body.employee;
    let employeeNum;
    length < 100 ? 
      employeeNum = new Array(3 + 1 - (length + '').length).join('0') + length
    : employeeNum = length
    return("EMP-" + employeeNum);
  };

  return (
    <Box>
      { !open ?
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end'
        }}
      >
        <Button
          color="primary"
          variant="contained"
          onClick={addEmployee}
        >
          New Employee
        </Button>
      </Box> : null }
      <Box sx={{ mt: 3 }}>
        { open ?
          ( update ?
            <EmployeeDetails
              update={update}
              employeeInfo={updateInfo}
              cancelAddUpdate={cancelAddUpdate}
            /> :
            <EmployeeDetails
              activeUserId={props.activeUserId}
              update={update}
              employeeInfo={{
                displayId: createEmployeeDisplayId(),
                name: "",
                phone: "",
                department: "Cashier",
                joiningDate: ""
              }}
              cancelAddUpdate={cancelAddUpdate}
            />
          ) :
          <EmployeesTable
            employees={props.employees}
            expenses={props.expenses}
            updateEmployee={updateEmployee}
            setUpdateInfo={setUpdateInfo}
          />
        }
      </Box>
    </Box>
  )
};

export default EmployeeListResults;